export default __webpack_public_path__ + "static/media/coupon.2b666252.svg";